/**
 * Copyright (c) 2018-present, Tomaruba, Inc.
 * All rights reserved.
 */
import { Record } from 'immutable'

const _SegmentCategoryState = {
  id: null,
  name: '',
  priority: null,
  status: 'show',
  segmentValues: [] // 一覧表示で使用
}

class SegmentCategoryState extends Record(_SegmentCategoryState) {
  toRequestBody() {
    return {
      id: this.id,
      name: this.name,
      priority: this.priority,
      status: this.status
    }
  }
}

export { SegmentCategoryState }
